import Vue from 'vue'
import Router from 'vue-router'
import { OktaAuth } from '@okta/okta-auth-js'
import OktaVue from '@okta/okta-vue'
import { LoginCallback } from '@okta/okta-vue'
import Home from '../pages/Home'
import More from '../pages/More'
import Terms from '../pages/Terms'
const { VUE_APP_CLIENT_ID, VUE_APP_ISSUER } = process.env

const oktaAuth = new OktaAuth({
  issuer: VUE_APP_ISSUER,
  clientId: VUE_APP_CLIENT_ID,
  redirectUri: `/login/callback`,
  scopes: ['openid', 'profile', 'email'],
})

Vue.use(Router)
Vue.use(OktaVue, { oktaAuth })

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login/callback',
      component: LoginCallback,
      name: 'redirect',
    },
    {
      path: '/',
      component: Home,
      name: 'home',
    },
    {
      path: '/terms-and-conditions',
      component: Terms,
      name: 'terms',
    },
    {
      path: '/more',
      component: More,
      name: 'more',
      meta: {
        requiresAuth: true,
      },
    },
  ],
  scrollBehavior() {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
  },
})
